import { DataModel } from './data-model';
import { PlanType } from '../../enums/user';

export class AssignedRoleDto {
    userId: number;
    fullName: string;
    isActive: boolean;
    roleId: number;
    mobile: string;
    externalUserId: string;
    emailId: string;
    landingPage: number;
    planType: PlanType;
    userIdByUser: string;
    userScreenList: Array<DataModel>;

    constructor() {
        this.userId = 0;
        this.fullName = '';
        this.isActive = false;
        this.roleId = 0;
        this.mobile = '';
        this.externalUserId = '';
        this.emailId = '';
        this.landingPage = 0;
        this.planType = PlanType.Trial;
        this.userScreenList = [];
        this.userIdByUser='';
    }
}
